export default {
    apiKey: "AIzaSyBXvGn6jistcx94jOvjhxl6qv6UTQlsMPQ",
    authDomain: "ayun-quantity-uat2.firebaseapp.com",
    projectId: "ayun-quantity-uat2",
    storageBucket: "ayun-quantity-uat2.appspot.com",
    messagingSenderId: "811774326584",
    appId: "1:811774326584:web:45c4331151c9733455b3cd",
    measurementId: "G-Y7026CXPTZ"
};